import { formValueSelector } from 'redux-form';
export const isSelected = (name, form) => state => formValueSelector(form)(state, `${name}.value.value`) === 'true';
const getAllAvailableSeatsForDeck = deck => {
  var _deck$cabins$flatMap;
  return (_deck$cabins$flatMap = deck === null || deck === void 0 ? void 0 : deck.cabins.flatMap(cabin => cabin === null || cabin === void 0 ? void 0 : cabin.rows.flatMap(row => {
    var _row$sellSeatMapSeats;
    return row === null || row === void 0 || (_row$sellSeatMapSeats = row.sellSeatMapSeats) === null || _row$sellSeatMapSeats === void 0 ? void 0 : _row$sellSeatMapSeats.filter(seat => (seat === null || seat === void 0 ? void 0 : seat.isBookable) && typeof seat.price === 'number');
  }))) !== null && _deck$cabins$flatMap !== void 0 ? _deck$cabins$flatMap : [];
};
const collectAllSeats = bounds => {
  const allSeats = [];
  for (const bound of bounds) {
    for (const segment of bound.sellSeatMapSegments) {
      allSeats.push(...getAllAvailableSeatsForDeck(segment.upperDeck));
      allSeats.push(...getAllAvailableSeatsForDeck(segment.mainDeck));
      allSeats.push(...getAllAvailableSeatsForDeck(segment.lowerDeck));
    }
  }
  return allSeats;
};
export const getMinPrice = bounds => {
  const prices = collectAllSeats(bounds).filter(seat => (seat === null || seat === void 0 ? void 0 : seat.price) && typeof seat.price === 'number').map(seat => seat.price);
  return prices.length > 0 ? Math.min(...prices) : 0;
};
//# sourceMappingURL=selection.js.map